(function () {
  'use strict';

  if (window.__nevFreeGiftLoaded) {
    if (typeof window.__nevFreeGiftSync === 'function') {
      window.__nevFreeGiftSync();
    }
    return;
  }

  window.__nevFreeGiftLoaded = true;

  const ROOT = window.Shopify?.routes?.root || '/';

  const GIFT_VARIANT_IDS = [
    59956760347008, // YZW3505
    59956760379776, // YZW3504
    59956692418944, // BN-2234
    59956692976000, // BN-2235
    59956760445312, // YZW3502
    59956692025728, // BN-2233
    59956693959040, // BN-2238
    59956693926272, // BN-2237
    59956687667584, // BN-2227
    59956688945536  // BN-2228
  ];

  const GIFT_VARIANT_SET = new Set(GIFT_VARIANT_IDS);
  const THRESHOLD_CENTS = 1200;
  const MAX_ELIGIBLE_ITEM_GRAMS = 500;

  const GIFT_PROPERTY_KEY = '_nev_free_gift';
  const GIFT_PROPERTY_VALUE = '1';

  const nativeFetch = window.fetch.bind(window);

  let syncRunning = false;
  let syncAgain = false;
  let syncTimer = null;

  async function fetchJson(url, options = {}) {
    const response = await nativeFetch(url, options);

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`${response.status} ${response.statusText}: ${text}`);
    }

    return response.json();
  }

  async function getCart() {
    return fetchJson(ROOT + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });
  }

  function hasGiftProperty(item) {
    return (
      item.properties &&
      String(item.properties[GIFT_PROPERTY_KEY]) === GIFT_PROPERTY_VALUE
    );
  }

  function isAutoGift(item) {
    return hasGiftProperty(item);
  }

  function isAllowedGift(item) {
    return (
      isAutoGift(item) &&
      GIFT_VARIANT_SET.has(Number(item.variant_id))
    );
  }

  function isCream(item) {
    const title = String(item.product_title || item.title || '').toLocaleLowerCase('bg-BG');
    const type = String(item.product_type || '').toLocaleLowerCase('bg-BG');

    return title.includes('крем') || type.includes('крем');
  }

  function isHeavy(item) {
    return Number(item.grams || 0) > MAX_ELIGIBLE_ITEM_GRAMS;
  }

  function isEligibleForThreshold(item) {
    if (isAutoGift(item)) return false;
    if (isHeavy(item)) return false;
    return true;
  }

  function hasNonCreamEligibleItem(items) {
    return items.some(item => (
      isEligibleForThreshold(item) &&
      !isCream(item)
    ));
  }

  function calculateQualifyingTotal(items) {
    return items.reduce((total, item) => {
      if (!isEligibleForThreshold(item)) return total;
      return total + Number(item.line_price || 0);
    }, 0);
  }

  function hashString(value) {
    let hash = 0;
    const str = String(value || '');

    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }

    return Math.abs(hash);
  }

  async function isVariantAvailable(variantId) {
    try {
      const variant = await fetchJson(
        ROOT + 'variants/' + variantId + '.js',
        {
          credentials: 'same-origin',
          cache: 'no-store'
        }
      );

      return variant.available === true;
    } catch (error) {
      console.warn('[nev-free-gift] Не успях да проверя наличността:', variantId, error);
      return false;
    }
  }

  async function chooseGiftVariant(cart) {
    if (!GIFT_VARIANT_IDS.length) return null;

    const startIndex = hashString(cart.token) % GIFT_VARIANT_IDS.length;

    for (let offset = 0; offset < GIFT_VARIANT_IDS.length; offset++) {
      const index = (startIndex + offset) % GIFT_VARIANT_IDS.length;
      const variantId = GIFT_VARIANT_IDS[index];

      if (await isVariantAvailable(variantId)) {
        return variantId;
      }
    }

    return null;
  }

  async function addGift(variantId) {
    return fetchJson(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE
            }
          }
        ]
      })
    });
  }

  async function changeLineQuantity(lineKey, quantity) {
    return fetchJson(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });
  }

  function reloadEurusCart() {
    document.dispatchEvent(
      new CustomEvent('eurus:cart:reload')
    );
  }

  async function syncGift() {
    if (syncRunning) {
      syncAgain = true;
      return;
    }

    syncRunning = true;
    syncAgain = false;

    let cartChanged = false;

    try {
      const cart = await getCart();
      const items = cart.items || [];

      const qualifyingTotal = calculateQualifyingTotal(items);
      const hasNonCreamItem = hasNonCreamEligibleItem(items);
      const autoGifts = items.filter(isAutoGift);
      const allowedAutoGifts = autoGifts.filter(isAllowedGift);

      const shouldHaveGift =
        qualifyingTotal >= THRESHOLD_CENTS &&
        hasNonCreamItem;

      if (!shouldHaveGift) {
        for (const gift of autoGifts) {
          await changeLineQuantity(gift.key, 0);
          cartChanged = true;
        }
      } else {
        for (const gift of autoGifts) {
          if (!isAllowedGift(gift)) {
            await changeLineQuantity(gift.key, 0);
            cartChanged = true;
          }
        }

        if (allowedAutoGifts.length === 0) {
          const giftVariantId = await chooseGiftVariant(cart);

          if (giftVariantId) {
            await addGift(giftVariantId);
            cartChanged = true;
          }
        } else {
          if (Number(allowedAutoGifts[0].quantity) !== 1) {
            await changeLineQuantity(allowedAutoGifts[0].key, 1);
            cartChanged = true;
          }

          for (let i = 1; i < allowedAutoGifts.length; i++) {
            await changeLineQuantity(allowedAutoGifts[i].key, 0);
            cartChanged = true;
          }
        }
      }
    } catch (error) {
      console.error('[nev-free-gift]', error);
    } finally {
      syncRunning = false;
    }

    if (cartChanged) {
      reloadEurusCart();
    }

    if (syncAgain) {
      scheduleSync(100);
    }
  }

  function scheduleSync(delay = 250) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGift, delay);
  }

  window.__nevFreeGiftSync = syncGift;

  document.addEventListener(
    'eurus:cart:items-changed',
    () => scheduleSync(250)
  );

  document.addEventListener(
    'eurus:product:added',
    () => scheduleSync(250)
  );

  function init() {
    scheduleSync(50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();